import { useSelector } from "react-redux";
import { selectCurrentUser } from "../redux/slices/authSlice";

const usePermissions = () => {
    const user = useSelector(selectCurrentUser);

    const has = (...permissions) => {
        if (!user) return false;
        if (user.role === "admin") return true;
        const userPerms = user.permissions || [];
        return permissions.some((p) => userPerms.includes(p));
    };

    return { has, permissions: user?.permissions || [], role: user?.role };
};

export default usePermissions;